var applyDelay = ms => new Promise(res => setTimeout(res, ms));
window.wineOrders = window.wineOrders || {};

// localStorage key

const lsKey     =   `__wineOrders__`;
const roughObj  =   {
  itemsCount: 0,
  items: [],
  upsellItems: [],
  giftItems: [],
  shipping: 'Ship Now',
  shipDate: '',
  toggleState: 'no',
  note: '',
  cartNote: '',
  total: 0,
  link: '',
  ship_hot_weather: 'No',
  spicesCount: 0,
  spicesItems: []
}
const giftModalState = {
  item: null,
  product: null,
  selectedVariantId: null
}

function safeNumber( value, fallback = 0 ) {
  const parsedValue = Number( value );
  return Number.isFinite( parsedValue ) ? parsedValue : fallback;
}

function getGiftItemByVariantId( variantId ) {
  let giftItem = $( `.wine-cart__gift__item[vid="${ variantId }"]` );

  if ( giftItem.length > 0 ) {
    return giftItem.first();
  }

  $( `.wine-cart__gift__item` ).each(function() {
    try {
      const item = $( this );
      const giftData = JSON.parse( item.find( `.wine-cart__gift__data` ).val() );
      if ( giftData && Array.isArray( giftData.variants ) && giftData.variants.some(variant => variant.id == variantId) ) {
        giftItem = item;
        return false;
      }
    } catch ( err ) {
      console.log( `ERROR getGiftItemByVariantId() item parse`, err.message );
    }
  })

  return giftItem.first();
}

wineOrders.getItems = (async function() {
  let rtn;
  await $.getJSON(`/cart.js`, function ( data ) {
    rtn = data;
  });
  return rtn;
})

$(document)
.ready(async function () {
  $( `body` )
    .removeClass( `overlay-shown` );
  manageOrders( `load` );
})
.on(`click`, `.intro__link.intro__link-hide`, function( e ) {
  try {
    e.stopImmediatePropagation();
    e.preventDefault();
    $( this )
      .closest( `.wine__intro` )
      .slideUp();
  } catch ( err ) {
    console.log( `ERROR .intro__link.intro__link-hide`, err.message );
  }
})
// CART ITEMS PLUS / MINUS / REMOVE START
.on(`click`, `.itemContent__qtyWrap__plus`, function( e ) {
  try {
    e.stopImmediatePropagation();
    let qty   =   $( this ).closest( `.itemContent__qtyWrap` ).find( `.itemContent__qtyWrap__input` ).val() * 1;
    qty       =   qty + 1;
    $( this ).closest( `.itemContent__qtyWrap` ).find( `.itemContent__qtyWrap__input` ).val( qty );
  } catch ( err ) {
    console.log( `ERROR .itemContent__qtyWrap__plus`, err.message );
  }
})
.on(`click`, `.itemContent__qtyWrap__minus`, function( e ) {
  try {
    e.stopImmediatePropagation();
    let qty   =   $( this ).closest( `.itemContent__qtyWrap` ).find( `.itemContent__qtyWrap__input` ).val() * 1;
    qty       =   qty - 1;
    if ( qty >= 0 ) {
      $( this ).closest( `.itemContent__qtyWrap` ).find( `.itemContent__qtyWrap__input` ).val( qty );
    }
  } catch ( err ) {
    console.log( `ERROR .itemContent__qtyWrap__minus`, err.message );
  }
})
.on(`click`, `.wine-cart .remove-item`,async function( e ) {
  try {
    e.stopImmediatePropagation();
    const cartItem = $( this ).closest( `.wine-cart__item` );
    const vid = cartItem.attr( `vid` ) * 1;
    const source = cartItem.attr( `source` ) || `product`;

    if ( source == 'product' ) {
      $( `.wine-main__item[vid="${ vid }"] .itemContent__act .itemContent__qtyWrap__input` ).val( 0 );
      $( `.wine-main__item[vid="${ vid }"] .itemContent__act .itemContent__btn` ).click();
      return;
    }

    if ( source == 'spices' ) {
      if ( roughObj.spicesCount > 0 ) {
        $( `.wine-cart__spacies__item .wine-cart__spacies__qtyWrap__input` ).val( 0 ).attr( `last-saved`, 0 );
        await roughObj.spicesItems.forEach(el => {
          const vid_ = el.id;
          const qty_ = el.quantity;
          $( `.wine-cart__spacies__item[vid="${ vid_ }"] .wine-cart__spacies__qtyWrap__input` ).val( qty_ ).attr( `last-saved`, qty_ );
        });

        $( `.wine-cart__spacies__item[vid="${ vid }"] .wine-cart__spacies__qtyWrap__input` ).val( 0 ).attr( `last-saved`, 0 );
      } else if ( roughObj.spicesCount == 0 ) {
        $( `.wine-cart__spacies__item .wine-cart__spacies__qtyWrap__input` ).val( 0 ).attr( `last-saved`, 0 );
      }

      addItems();
      return;
    }

    if ( source == 'gift' ) {
      $( `.wine-cart__gift__item[vid="${ vid }"]` ).attr( `cart`, 0 );
      addItems();
      return;
    }

    $( `.wine-cart__upsell__item[vid="${ vid }"]` ).attr( `cart`, 0 );
    addItems();
  } catch ( err ) {
    console.log( `ERROR .wine-cart .remove-item`, err.message );
  }
})
// CART ITEMS PLUS / MINUS / REMOVE END

// ITEM MODAL EVENTS START
.on(`click`, `.wine-main__item--imgWrap`, function( e ) {
  try {
    e.stopImmediatePropagation();
    let getJSON   =   $( this ).closest( `.wine-main__item` ).find( `textarea` ).val();
    getJSON       =   JSON.parse( getJSON );
    if ( typeof getJSON !== 'undefined' && getJSON ) {
      modalOpen( getJSON );
      $( `.wine-modal` )
        .fadeIn();
    }
  } catch ( err ) {
    console.log( `ERROR .wine-main__item--imgWrap`, err.message );
  }
})
.on(`click`, `.wine-modal__centerCenter__close`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( `.wine-modal__content` ).html( `` );
    giftModalState.item = null;
    giftModalState.product = null;
    giftModalState.selectedVariantId = null;
    $( `.wine-modal` )
      .fadeOut();
    $( `body` )
      .removeClass( `disabled` );
  } catch ( err ) {
    console.log( `ERROR .wine-main__item--imgWrap`, err.message );
  }
})
.on(`click`, `.wine-modal:not(.wine-modal__centerCenter)`, function( e ) {
  try {
    e.stopImmediatePropagation();
    if ( e.target !== this ) {
      return;
    }
    $( `.wine-modal__centerCenter__close` ).click();
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
})
// ITEM MODAL EVENTS END

// CART PANEL SHOW / HIDE START
.on(`click`, `.wine-header__cart`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const getStatus = $( `.wine-cart` ).attr( `visibility` );

    if ( getStatus == false ) {
      $( `.wine-cart` )
        .attr( `visibility`, fasle )
        .closest( `body` )
        .removeClass( `overLay` );
    } else {
      $( `.wine-cart` )
        .attr( `visibility`, true )
        .closest( `body` )
        .addClass( `overLay` );

    cartPanelSetHeight();
    }
  } catch ( err ) {
    console.log( `ERROR .wine-header__cart`, err.message );
  }
})
.on(`click`, `.wine-cart__close`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( this )
      .closest( `.wine-cart` )
      .attr( `visibility`, false )
      .closest( `body` )
      .removeClass( `overLay` );
  } catch ( err ) {
    console.log( `ERROR .wine-cart__close`, err.message );
  }
})

.on(`blur`, `.wine-cart__cartNote-textarea`, function( e ) {
  try {
    e.stopImmediatePropagation();
    addItems();
  } catch ( err ) {
    console.log( `ERROR .wine-cart__cartNote-textarea`, err.message );
  }
})

// CART PANEL SHOW / HIDE START
.on(`click`, `.toggle`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const getStatus = $( this ).attr( `status` );
    if ( getStatus == 'yes' ) {
      $( this ).attr( `status`, `no` );
      roughObj.toggleState = 'no'
    } else if ( getStatus == 'no' ) {
      $( this ).attr( `status`, `yes` );
      roughObj.toggleState = 'yes'
    }
    addItems();
  } catch ( err ) {
    console.log( `ERROR .toggle`, err.message );
  }
})
// ADD TO CART ITEMS START
.on(`click`, `.itemContent__act .itemContent__btn`, function( e ) {
  try {
    e.stopImmediatePropagation();
    addItems();
    $( `.wine-header__cart [cart-count]` ).click();
  } catch ( err ) {
    console.log( `ERROR .itemContent__act .itemContent__btn`, err.message );
  }
})
.on(`click`, `.wine-cart__spacies__btn`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const thisQty = $( this ).closest( `.wine-cart__spacies__item` ).find( `.wine-cart__spacies__qtyWrap__input` ).val();
    if ( roughObj.spicesCount > 0 ) {
      $( `.wine-cart__spacies__item .wine-cart__spacies__qtyWrap__input` ).val( 0 );
      roughObj.spicesItems.forEach(el => {
        const vid = el.id;
        const qty = el.quantity;
        $( `.wine-cart__spacies__item[vid="${ vid }"] .wine-cart__spacies__qtyWrap__input` ).val( qty );
      });
    } else if ( roughObj.spicesCount == 0 ) {
      $( `.wine-cart__spacies__item .wine-cart__spacies__qtyWrap__input` ).val( 0 );
    }
    console.log ( 'thisQty', thisQty );
    $( this ).closest( `.wine-cart__spacies__item` ).find( `.wine-cart__spacies__qtyWrap__input` ).val( thisQty );
    addItems();
    $( `.wine-header__cart [cart-count]` ).click();
  } catch ( err ) {
    console.log( `ERROR .wine-cart__spacies__btn`, err.message );
  }
})
// ADD TO CART ITEMS END

.on(`change`, `#shipDate`, function( e ) {
  try {
    e.stopImmediatePropagation();
    addItems();
  } catch ( err ) {
    console.log( `ERROR #shipDate`, err.message );
  }
})
.on(`click`, `body.overLay .timesact_bis_popup_overlay`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( `.wine-cart__close` ).click();
  } catch ( err ) {
    console.log( `ERROR body.overLay .timesact_bis_popup_overlay`, err.message );
  }
})
.on(`click`, `.wine-cart__upsell__btn`, function( e ) {
  try {
    e.stopImmediatePropagation();
    let qty = $( this ).closest( `.wine-cart__upsell__item` ).attr( `cart` ) * 1;
    const limit = $( this ).closest( `.wine-cart__upsell__item` ).attr( `limit` ) * 1;
    if ( limit > qty ) {
      $( this ).closest( `.wine-cart__upsell__item` ).attr( `cart`, `${ qty + 1 }` );
      addItems();
    }
  } catch ( err ) {
    console.log( `ERROR .wine-cart__upsell__btn`, err.message );
  }
})
.on(`click`, `.wine-cart__gift__item`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const item = $( this );
    if ( item.attr( `data-disabled` ) == 'true' ) {
      return;
    }

    let getJSON = item.find( `.wine-cart__gift__data` ).val();
    getJSON = JSON.parse( getJSON );
    if ( typeof getJSON !== 'undefined' && getJSON ) {
      modalOpenGift( getJSON, item );
      $( `.wine-modal` ).fadeIn();
    }
  } catch ( err ) {
    console.log( `ERROR .wine-cart__gift__item`, err.message );
  }
})
.on(`click`, `.wine-cart__gift__btn`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( this ).closest( `.wine-cart__gift__item` ).click();
  } catch ( err ) {
    console.log( `ERROR .wine-cart__gift__btn`, err.message );
  }
})
.on(`change`, `.wine-modal__giftVariant`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const variantId = $( this ).val() * 1;
    updateGiftModalVariant( variantId );
  } catch ( err ) {
    console.log( `ERROR .wine-modal__giftVariant`, err.message );
  }
})
.on(`click`, `.wine-modal__giftAddBtn`, function( e ) {
  try {
    e.stopImmediatePropagation();
    addGiftVariantToCart();
  } catch ( err ) {
    console.log( `ERROR .wine-modal__giftAddBtn`, err.message );
  }
})
.on(`click`, `.wine-cart__spacies__qtyWrap__minus`, function( e ) {
  try {
    e.stopImmediatePropagation();
    let min   =   $( this ).closest( `.wine-cart__spacies__qtyWrap` ).find( `.wine-cart__spacies__qtyWrap__input` ).attr( `min` ) * 1;
    let max   =   $( this ).closest( `.wine-cart__spacies__qtyWrap` ).find( `.wine-cart__spacies__qtyWrap__input` ).attr( `max` ) * 1;
    let qty   =   $( this ).closest( `.wine-cart__spacies__qtyWrap` ).find( `.wine-cart__spacies__qtyWrap__input` ).val() * 1;
    qty       =   qty - 1;
    if ( qty >= min ) {
      $( this ).closest( `.wine-cart__spacies__qtyWrap` ).find( `.wine-cart__spacies__qtyWrap__input` ).val( qty );
    }
    setMaxQty();
  } catch ( err ) {
    console.log( `ERROR .wine-cart__spacies__qtyWrap__minus`, err.message );
  }
})
.on(`click`, `.wine-cart__spacies__qtyWrap__plus`, function( e ) {
  try {
    e.stopImmediatePropagation();
    let min   =   $( this ).closest( `.wine-cart__spacies__qtyWrap` ).find( `.wine-cart__spacies__qtyWrap__input` ).attr( `min` ) * 1;
    let max   =   $( this ).closest( `.wine-cart__spacies__qtyWrap` ).find( `.wine-cart__spacies__qtyWrap__input` ).attr( `max` ) * 1;
    let qty   =   $( this ).closest( `.wine-cart__spacies__qtyWrap` ).find( `.wine-cart__spacies__qtyWrap__input` ).val() * 1;
    qty       =   qty + 1;

    console.log ( 'chaaa', qty );

    let getQty = 0;
    $( `.wine-cart__spacies__item` ).each( function() {
      const q = safeNumber( $( this ).find( `.wine-cart__spacies__qtyWrap__input` ).val() );
      getQty = getQty + q;
    })

    const allowMax = safeNumber( $( `.wine-cart__spacies__noteMsg` ).attr( `allow-max` ) );

    if ( qty <= max && roughObj.spicesCount < max ) {
      // console.log ( 'getQty', getQty );
      if ( getQty < allowMax ) {
        $( this ).closest( `.wine-cart__spacies__qtyWrap` ).find( `.wine-cart__spacies__qtyWrap__input` ).val( qty );
      }
    }
    setMaxQty();
  } catch ( err ) {
    console.log( `ERROR .wine-cart__spacies__qtyWrap__plus`, err.message );
  }
})
.on(`click`, `.shipToggle #shipYes`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const isChecked = $( this ).is( `:checked` );
    if ( isChecked ) {
      $( `.toggle` ).attr( `status`, 'no' );
      addItems();
    }
  } catch ( err ) {
    console.log( `ERROR .shipToggle #shipYes`, err.message );
  }
})
.on(`click`, `.shipToggle #shipNo`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const isChecked = $( this ).is( `:checked` );
    if ( isChecked ) {
      $( `.toggle` ).attr( `status`, 'yes' );
      addItems();
    }
  } catch ( err ) {
    console.log( `ERROR .shipToggle #shipNo`, err.message );
  }
})
.on(`click`, `.wine-cart__cartFooter__checkout`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const getURL = $( this ).attr( `url` );
    if ( typeof getURL !== 'undefined' && getURL ) {
      window.history.pushState({}, '', '?setdata=yes');
      const cartObject    =   localStorage.getItem( lsKey );
      localStorage.setItem( `__checkoutClicked__`, cartObject );
      localStorage.removeItem( lsKey );
      location.href = getURL;
    }
  } catch ( err ) {
    console.log( `ERROR .wine-cart__cartFooter__checkout`, err.message );
  }
})

.on(`change`, `[name="hotWeatherOption"]`, function( e ) {
  try {
    e.stopImmediatePropagation();
    addItems();
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
})

// REFRESH CART START
.on(`click`, `.wine-header__cartRefresh`, function( e ) {
  try {
    e.stopImmediatePropagation();
    localStorage.setItem( lsKey, '' );
    location.href = '?';
  } catch ( err ) {
    console.log( `ERROR .wine-header__cartRefresh`, err.message );
  }
})
// REFRESH CART END


.on(`click`, `.wine-main__item--variant`, function( e ) {
  try {
    e.stopImmediatePropagation();
    e.preventDefault();

    const vid = $( this ).attr( `vid` );

    $( this )
      .closest( `.wine-main__item--variants` )
      .find( `.wine-main__item--variant` )
      .removeClass( `active` );

    $( this ).addClass( `active` );

    $( this )
      .closest( `.wine-main__item` )
      .attr( `vid`, vid );

  } catch ( err ) {
    console.log( `ERROR .wine-main__item--variant`, err.message );
  }
})
;

$( document )
.mouseup(function( e ) {
  try {
    const container		=		$( `.wine-cart` );
    if ( !container.is( e.target ) && container.has( e.target ).length === 0 ) {
      container.find( `.wine-cart__head .wine-cart__close` ).click();
    }
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
});

function setMaxQty() {
  try {
    if ( typeof spicesText === 'undefined' || !spicesText || $( `.wine-cart__spacies__noteMsg` ).length == 0 ) {
      return;
    }

    const allowCans = safeNumber(
      $( `.wine-cart__spacies__noteMsg` ).attr( `allow-cans` ),
      safeNumber( $( `.wine-cart__spacies__noteMsg` ).attr( `allow-max` ) )
    );
    let getTotalCans = 0;
    $( `.wine-cart__spacies__item` ).each( function() {
      const qty = safeNumber( $( this ).find( `.wine-cart__spacies__qtyWrap__input` ).val() );
      if ( qty > 0 ) {
        getTotalCans += qty;
      }
    })

    const limitLeft = Math.max( allowCans - getTotalCans, 0 );

    if ( limitLeft != 0 ) {
      const spicesText__updated = spicesText.replace( `[NUMBER]`, `<b>${ limitLeft }</b>` );
      $( `.wine-cart__spacies__noteMsg` ).html( spicesText__updated ).removeClass( `err` );
    } else {
      const bottleCount = safeNumber( roughObj.itemsCount );
      const spicesShortfallText = bottleCount == 1 ? 'Add 1 more bottle to get 1 spices to your cart' : 'No option left';
      $( `.wine-cart__spacies__noteMsg` ).html( spicesShortfallText ).addClass( `err` );
    }
  } catch ( err ) {
    console.log( `ERROR setMaxQty()`, err.message );
  }
}

function eligibleUpsell( itemsCount = 0 ) {
  try {
    $( `.wine-cart__upsell .wine-cart__upsell__item` ).each(function() {
      const alreadyInCart = $( this ).attr( `cart` ) * 1;
      const limit = $( this ).attr( `limit` ) * 1;
      if ( limit > alreadyInCart ) {
        $( this ).removeClass( `hide` );
      } else {
        $( this ).addClass( `hide` );
      }
    })
  } catch ( err ) {
    console.log( `ERROR eligibleUpsell()`, err.message );
  }
}

function eligibleGift() {
  try {
    let giftInCart = 0;
    $( `.wine-cart__gift .wine-cart__gift__item` ).each(function() {
      giftInCart += $( this ).attr( `cart` ) * 1;
    })

    $( `.wine-cart__gift .wine-cart__gift__item` ).each(function() {
      const limit = $( this ).attr( `limit` ) * 1;
      if ( limit > 0 && giftInCart < limit ) {
        $( this )
          .removeClass( `hide disabled` )
          .attr( `data-disabled`, false )
          .attr( `aria-disabled`, false )
          .find( `.wine-cart__gift__btn` )
          .prop( `disabled`, false );
      } else {
        $( this )
          .removeClass( `hide` )
          .addClass( `disabled` )
          .attr( `data-disabled`, true )
          .attr( `aria-disabled`, true )
          .find( `.wine-cart__gift__btn` )
          .prop( `disabled`, true );
      }
    })
  } catch ( err ) {
    console.log( `ERROR eligibleGift()`, err.message );
  }
}

function manageOrders( type = '' ) {
  try {
    let mainObject  =   localStorage.getItem( lsKey );
    if ( typeof mainObject !== 'undefined' && mainObject ) {
      mainObject      =   JSON.parse( mainObject );

      console.log ( 'mainObject', mainObject );

      if ( type == 'load' ) {
        $( `.wine-header__cart [cart-count] span` ).text( mainObject.itemsCount );
        let collectItems = '';
        mainObject.items.forEach(el => {
          const vid = el.id;
          const qty = el.quantity;
          const img = el.img;
          const title = el.title;
          const price = el.price;

          collectItems +=   setHTML( vid, img, title, qty, price, 'product' );
          $( `.wine-main__item[vid="${ vid }"] .itemContent__act .itemContent__qtyWrap__input` ).val( qty );
          if ( qty > 0 ) {
            $( `.wine-main__item[vid="${ vid }"] .itemContent__act .itemContent__btn` ).text( 'Update Cart' );
          }
        });

        if ( Array.isArray( mainObject.upsellItems ) && mainObject.upsellItems.length > 0 ) {
          mainObject.upsellItems.forEach(el => {
            const vid = el.id;
            const qty = el.quantity;
            const img = el.img;
            const title = el.title;
            const price = el.price;

            collectItems +=   setHTML( vid, img, title, qty, price, 'upsell' );
            $( `.wine-cart__upsell__item[vid="${ vid }"]` ).attr( `cart`, qty );
          });
        }
        if ( Array.isArray( mainObject.giftItems ) && mainObject.giftItems.length > 0 ) {
          mainObject.giftItems.forEach(el => {
            const vid = el.id;
            const qty = el.quantity;
            const img = el.img;
            const title = el.title;
            const price = el.price;
            const giftItem = getGiftItemByVariantId( vid );

            collectItems +=   setHTML( vid, img, title, qty, price, 'gift' );
            if ( giftItem.length > 0 ) {
              giftItem
                .attr( `cart`, qty )
                .attr( `vid`, vid )
                .attr( `product-img`, img )
                .attr( `product-price`, price );

              giftItem.find( `.wine-cart__gift__img img` ).attr( `src`, img );
            }
          });
        }
        if ( mainObject.spicesCount > 0 ) {
          mainObject.spicesItems.forEach(el => {
            const vid = el.id;
            const qty = el.quantity;
            const img = el.img;
            const title = el.title;
            const price = el.price;

            collectItems +=   setHTML( vid, img, title, qty, price, 'spices' );
            $( `.wine-cart__spacies__item[vid="${ vid }"] .wine-cart__spacies__qtyWrap__input` ).val( qty );
          });
        }
        $( `.wine-cart__items` )
          .html( collectItems );
        $( `.toggle` )
          .attr( `status`, mainObject.toggleState );
        if ( mainObject.toggleState == 'no' ) {
          $( `.shipToggle #shipYes` ).prop( 'checked', true );
          // $( `.shipToggle #shipYes` ).prop( 'checked', false );
        } else {
          $( `.shipToggle #shipNo` ).prop( 'checked', true );
        }
        if ( mainObject.shipDate != '' ) {
          console.log ( 'mainObject.date', mainObject.shipDate );
          $( `#shipDate` )
            .val( mainObject.shipDate );
        }
        if ( mainObject.ship_hot_weather == 'No' ) {
          $( `#hotWeatherNo` ).prop( 'checked', true );
        } else if ( mainObject.ship_hot_weather == 'Yes' ) {
          $( `#hotWeatherYes` ).prop( 'checked', true );
        } else {
          console.log ( 'chaaaaaaaa',  );
          $( `#hotWeatherNo` ).prop( 'checked', true );
        }
        if ( typeof mainObject.cartNote !== 'undefined' && mainObject.cartNote ) {
          $( `.wine-cart__cartNote-textarea` ).val( mainObject.cartNote );
        }
        addItems();
      }
    }
  } catch ( err ) {
    console.log( `ERROR manageOrders()`, err.message );
  }
}

function addItems() {
  try {
    const items = [];
    let count = 0;
    let itemsHTML = '';
    let total = 0;
    $( `.wine-main-products .wine-main__item` ).each(function() {
      const qty = $( this ).find( `.itemContent__qtyWrap__input` ).val() * 1;
      const vid = $( this ).attr( `vid` ) * 1;
      const title = $( this ).attr( `product-title` ).trim();
      const img = $( this ).attr( `product-img` ).trim();
      const price = $( this ).attr( `product-price` ).trim() * 1;
      const isPreOrder = $( this ).attr( `is-preorder` );

      if ( qty > 0 ) {
        const subTotal = price * qty;
        total = total + subTotal;
        $( this ).find( `.itemContent__btn` ).text( `Update Cart` );
        count = count + qty;
        items.push({
          id: vid,
          quantity: qty,
          title: title,
          img: img,
          price: price
        });
        itemsHTML  +=   setHTML( vid, img, title, qty, price, 'product' );
      } else {
        if ( typeof isPreOrder !== 'undefined' && isPreOrder ) {
          $( this ).find( `.itemContent__btn` ).text( `Pre Order Now` );
        } else {
          $( this ).find( `.itemContent__btn` ).text( `Add to Cart` );
        }
      }
    })
    $( `.wine-header__cart [cart-count] span` ).text( count );
    roughObj.items = items;
    roughObj.itemsCount = count;
    const getToggleState = $( `.wine-cart__cartImmediateShip__toggle` ).attr( `status` );
    roughObj.toggleState = getToggleState
    $( `.wine-cart__items` ).html( itemsHTML );
    const toggleStatus = $( `.toggle` ).attr( `status` );
    roughObj.toggleState = ( toggleStatus == 'no' ? 'no' : 'yes' );
    let note = 'Ship Now';
    const date = $( `#shipDate` ).val();
    if ( toggleStatus == 'yes' && date != '' ) {
      note = `Ship After ${ date }`;
    }
    if ( date != '' ) {
      roughObj.shipDate = date;
    }

    const cartNoteVal = $( `.wine-cart__cartNote-textarea` ).val();

    roughObj.note = `${ note }`;

    roughObj.cartNote = cartNoteVal;

    const upsellItems = [];
    $( `.wine-cart__upsell .wine-cart__upsell__item` ).each(function() {
      const cartItem = $( this ).attr( `cart` ) * 1;
      const img = $( this ).attr( `product-img` );
      const title = $( this ).attr( `product-title` );
      const price = $( this ).attr( `product-price` ).trim() * 1;
      const vid = $( this ).attr( `vid` ) * 1;
      if ( cartItem > 0 ) {
        const subTotal = price * cartItem;
        total = total + subTotal;
        $( `.wine-cart__items` )
          .append( setHTML( vid, img, title, cartItem, price, 'upsell' ) );
        upsellItems.push({
          id: vid,
          img: `${ img }`,
          price: price,
          quantity: cartItem,
          title: `${ title }`
        });
      }
    })
    const giftItems = [];
    let giftAlreadyAdded = 0;
    const allowedGiftCount = Math.floor( count / 2 );
    $( `.wine-cart__gift .wine-cart__gift__item` ).each(function() {
      const cartItem = $( this ).attr( `cart` ) * 1;
      const img = $( this ).attr( `product-img` );
      const title = $( this ).attr( `product-title` );
      const price = $( this ).attr( `product-price` ).trim() * 1;
      const vid = $( this ).attr( `vid` ) * 1;
      const giftQty = Math.min( cartItem, allowedGiftCount - giftAlreadyAdded );
      if ( giftQty > 0 ) {
        giftAlreadyAdded += giftQty;
        $( this ).attr( `cart`, giftQty );
        const subTotal = price * giftQty;
        total = total + subTotal;
        $( `.wine-cart__items` )
          .append( setHTML( vid, img, title, giftQty, price, 'gift' ) );
        giftItems.push({
          id: vid,
          img: `${ img }`,
          price: price,
          quantity: giftQty,
          title: `${ title }`
        });
      } else if ( cartItem > 0 ) {
        $( this ).attr( `cart`, 0 );
      }
    })
    const spicesItems = [];
    let spicesCount = 0;
    $( `.wine-cart__spacies__item` ).each(function() {
      const cartItem = $( this ).find( `.wine-cart__spacies__qtyWrap__input` ).val() * 1;
      const img = $( this ).attr( `product-img` );
      const title = $( this ).attr( `product-title` );
      const price = $( this ).attr( `product-price` ).trim() * 1;
      const vid = $( this ).attr( `vid` ) * 1;
      if ( cartItem > 0 ) {
        const subTotal = price * cartItem;
        total = total + subTotal;
        $( `.wine-cart__items` )
          .append( setHTML( vid, img, title, cartItem, price, 'spices' ) );
        spicesCount += cartItem;
        spicesItems.push({
          id: vid,
          img: `${ img }`,
          price: price,
          quantity: cartItem,
          title: `${ title }`
        });
      }
    })

    roughObj.spicesCount = spicesCount;
    roughObj.spicesItems = spicesItems;
    roughObj.upsellItems = upsellItems;
    roughObj.giftItems = giftItems;

    if ( roughObj.itemsCount == 0 && spicesCount == 0 ) {
      $( `.wine-cart__spacies__qtyWrap__input` ).val( 0 );
    }

    roughObj.total = total;

    $( `.wine-cart__cartSubTotal__price` ).text( `$${ total.toFixed(2) }` );

    manageUpsell( count );
    manageGift( count );

    const hotWeatherOption = $( `#hotWeatherNo` ).is( ':checked' );
    if ( hotWeatherOption ) {
      roughObj.ship_hot_weather = 'No';
    } else {
      roughObj.ship_hot_weather = 'Yes';
    }

    roughObj.note = `${ note }\nHold for hot weather: ${ roughObj.ship_hot_weather }\n-------\nCart Note: ${ cartNoteVal }`;

    const getLink = generateLink( roughObj );

    roughObj.link = getLink;

    localStorage.setItem( `${ lsKey }`, JSON.stringify( roughObj ) );
    eligibleUpsell();
    eligibleGift();

    $( `.wine-cart__cartFooter__checkout` ).attr( `url`, getLink );

    if ( count == 0 ) {
      $( `.wine-cart__empty` ).show();
      $( `.wine-cart__base` )
        .hide();
    } else {
      $( `.wine-cart__empty` ).hide();
      $( `.wine-cart__base` )
        .removeAttr( `style` );
    }

    manageSpices();
  } catch ( err ) {
    console.log( `ERROR addItems`, err.message );
  }
}

async function cartPanelSetHeight() {
  try {
    await applyDelay( 300 );
    const cartHeight        =   $( `.wine-cart` ).outerHeight();
    const cartHeadHeight    =   $( `.wine-cart__head` ).outerHeight();
    // const cartMiddleHeight  =   $( `.wine-cart__middle` ).outerHeight();
    const cartFooterHeight  =   $( `.wine-cart__base` ).outerHeight();
    const middleHeight      =   cartHeight - cartHeadHeight - cartFooterHeight;
    // if ( middleHeight > 120 ) {
    //   $( `.wine-cart__middle` ).css( `height`, `${ middleHeight - 10 }px` );
    // }
  } catch ( err ) {
    console.log( `ERROR cartPanelSetHeight()`, err.message );
  }
}

function generateLink( o ) {
  try {
    let link = '/cart/';
    let groupArrays = []
      .concat( o.items || [] )
      .concat( o.upsellItems || [] )
      .concat( o.giftItems || [] )
      .concat( o.spicesItems || [] );

    groupArrays.forEach((el, i) => {
      if ( i == 0 ) {
        link = `${ link }${ el.id }:${ el.quantity }`;
      } else {
        link = `${ link },${ el.id }:${ el.quantity }`;
      }
    });

    link  =  `${ link }?note=${ encodeURI( o.note ) }&attributes[page]=${ currentPage }`;
    return link;
  } catch ( err ) {
    console.log( `ERROR generateLink`, err.message );
  }
}


function manageUpsell( cartItemsCount ) {
  try {
    if ( cartItemsCount == 0 ) {
      $( `.wine-cart__upsell__item[item="1"]` )
        .attr( `limit`, 0 );
    } else if ( cartItemsCount <= 11 ) {
      $( `.wine-cart__upsell__item[item="1"]` )
        .attr( `limit`, 1 );
    } else if ( cartItemsCount <= 22 ) {
      $( `.wine-cart__upsell__item[item="1"]` )
        .attr( `limit`, 2 );
    } else if ( cartItemsCount <= 33 ) {
      $( `.wine-cart__upsell__item[item="1"]` )
        .attr( `limit`, 3 );
    } else if ( cartItemsCount <= 44 ) {
      $( `.wine-cart__upsell__item[item="1"]` )
        .attr( `limit`, 4 );
    }

    if ( cartItemsCount > 3 ) {
      $( `.wine-cart__upsell__item[item="2"]` )
        .attr( `limit`, 1 );
    } else {
      $( `.wine-cart__upsell__item[item="2"]` )
        .attr( `limit`, 0 );
    }
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}

function manageGift( cartItemsCount ) {
  try {
    const giftLimit = Math.floor( cartItemsCount / 2 );

    $( `.wine-cart__gift__item` )
      .attr( `limit`, giftLimit );

    if ( $( `.wine-cart__gift__noteMsg` ).length > 0 ) {
      let giftInCart = 0;
      $( `.wine-cart__gift .wine-cart__gift__item` ).each(function() {
        giftInCart += safeNumber( $( this ).attr( `cart` ) );
      })

      const giftLeft = Math.max( giftLimit - giftInCart, 0 );
      if ( giftLeft > 0 ) {
        $( `.wine-cart__gift__noteMsg` )
          .html( `You can add <b>${ giftLeft }</b> gift to your cart` )
          .removeClass( `err` );
      } else {
        const giftShortfallText = cartItemsCount % 2 == 1 ? 'Add 1 more bottle to get 1 gift to your cart' : 'No option left';
        $( `.wine-cart__gift__noteMsg` )
          .html( giftShortfallText )
          .addClass( `err` );
      }
    }
  } catch ( err ) {
    console.log( `ERROR manageGift()`, err.message );
  }
}


function manageSpices() {
  try {
    if ( typeof spicesText === 'undefined' || !spicesText || $( `.wine-cart__spacies__noteMsg` ).length == 0 ) {
      return;
    }

    const bottleCount = safeNumber( roughObj.itemsCount );
    let halfCount = bottleCount;
    if ( bottleCount > 0 ) {
      halfCount = Math.floor( bottleCount / 2 );
    }
    $( `.wine-cart__spacies__noteMsg` ).attr( `allow-max`, halfCount );
    // if ( roughObj.spicesCount > 0 ) {
    //   halfCount = halfCount - roughObj.spicesCount;
    // }

    if ( halfCount > 0 ) {
      $( `.wine-cart__spacies__qtyWrap__input` ).attr( `max`, halfCount );
      const spicesText__updated = spicesText.replace( `[NUMBER]`, `<b>${ halfCount }</b>` );
      $( `.wine-cart__spacies__noteMsg` ).html( spicesText__updated ).removeClass( `err` ).attr( `allow-cans`, halfCount );
    } else {
      if ( typeof spicesText !== 'undefined' && spicesText ) {
        const spicesShortfallText = bottleCount == 1 ? 'Add 1 more bottle to get 1 spices to your cart' : 'No option left';
        $( `.wine-cart__spacies__noteMsg` ).html( spicesShortfallText ).addClass( `err` );
        $( `.wine-cart__spacies__noteMsg` ).attr( `allow-cans`, 0 );
        $( `.wine-cart__spacies__qtyWrap__input` ).attr( `max`, 0 );
      }
    }
    setMaxQty();
  } catch ( err ) {
    console.log( `ERROR manageSpices()`, err.message );
  }
}

function setHTML( vid, img, title, qty, price, source = 'product' ) {
  try {
    let priceCalc = ``;
    if ( price == 0 ) {
      priceCalc = `Free`;
    } else {
      priceCalc = `$${ (qty * price).toFixed(2) }`;
      // priceCalc = `$${ ( priceCalc ).toFixed(0) }`;
    }

    return `
      <div class="wine-cart__item" vid="${ vid }" source="${ source }">
        <img src="${ img }" alt="${ title }" class="wine-cart__item__img">
        <div class="wine-cart__item__content">
          <div class="wine-cart__item__contentTitle">
            ${ title }
          </div>
          <div class="wine-cart__item__contentQty">
            ${ qty } x $${ price }
          </div>

          <div class="wine-cart__item__contentTotal">
            <pirce>
              ${ priceCalc }
            </pirce>
            <div class="remove-item ${ priceCalc == `Free` ? `upsell-item` : `` }">
              Remove
            </div>
          </div>
        </div>
      </div>
    `;
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}


function modalOpen( obj ) {
  try {
    $( `.wine-modal__content` )
      .html( `
        <modal-image>
          <img src="${ obj.img }" alt="${ obj.title }">
        </modal-image>
        <modal-content>
          ${ typeof obj.preorder !== 'undefined' && obj.preorder != '' ? `
            <modal-preorder>${ obj.preorder }</modal-preorder>
          ` : `` }
          <modal-title>${ obj.title }</modal-title>
          <modal-price>${ obj.price }</modal-price>
          <modal-description>${ obj.description }</modal-description>
        </modal-content>
      ` );
    $( `body` )
      .addClass( `disabled` );
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}

function modalOpenGift( obj, item ) {
  try {
    if ( !obj || !Array.isArray( obj.variants ) || obj.variants.length == 0 ) {
      return;
    }

    giftModalState.item = item;
    giftModalState.product = obj;
    giftModalState.selectedVariantId = obj.variants[0].id;

    const variantsHTML = obj.variants.map(( variant, index ) => `
      <label class="wine-modal__giftVariantOption">
        <input
          type="radio"
          name="wine-modal-gift-variant"
          class="wine-modal__giftVariant hide"
          value="${ variant.id }"
          ${ index === 0 ? `checked` : `` }
        >
        <span>${ variant.title }</span>
      </label>
    `).join( `` );

    $( `.wine-modal__content` )
      .html( `
        <modal-image>
          <img src="${ obj.variants[0].img || obj.img }" alt="${ obj.title }">
        </modal-image>
        <modal-content class="wine-modal__giftContent">
          <modal-title>${ obj.title }</modal-title>
          <modal-price>$${ obj.variants[0].rawPrice }</modal-price>
          <modal-description>${ obj.description || `` }</modal-description>
          <div class="wine-modal__giftVariantWrap">
            <div class="wine-modal__giftVariantList">
              ${ variantsHTML }
            </div>
          </div>
          <button class="wine-modal__giftAddBtn">Add to cart</button>
        </modal-content>
      ` );
    $( `body` )
      .addClass( `disabled` );
  } catch ( err ) {
    console.log( `ERROR modalOpenGift`, err.message );
  }
}

function updateGiftModalVariant( variantId ) {
  try {
    if ( !giftModalState.product || !Array.isArray( giftModalState.product.variants ) ) {
      return;
    }

    const variant = giftModalState.product.variants.find(el => el.id == variantId);
    if ( !variant ) {
      return;
    }

    giftModalState.selectedVariantId = variant.id;
    $( `.wine-modal modal-image img` ).attr( `src`, variant.img || giftModalState.product.img );
    $( `.wine-modal modal-price` ).html( `$${ variant.rawPrice }` );
  } catch ( err ) {
    console.log( `ERROR updateGiftModalVariant`, err.message );
  }
}

function addGiftVariantToCart() {
  try {
    if ( !giftModalState.item || !giftModalState.product || !giftModalState.selectedVariantId ) {
      return;
    }

    const variant = giftModalState.product.variants.find(el => el.id == giftModalState.selectedVariantId);
    if ( !variant ) {
      return;
    }

    const limit = giftModalState.item.attr( `limit` ) * 1;
    let giftInCart = 0;
    $( `.wine-cart__gift__item` ).each(function() {
      giftInCart += $( this ).attr( `cart` ) * 1;
    })

    if ( limit > 0 && giftInCart < limit ) {
      let qty = giftModalState.item.attr( `cart` ) * 1;
      giftModalState.item
        .attr( `cart`, `${ qty + 1 }` )
        .attr( `vid`, variant.id )
        .attr( `product-img`, variant.img || giftModalState.product.img )
        .attr( `product-price`, variant.rawPrice );

      giftModalState.item.find( `.wine-cart__gift__img img` ).attr( `src`, variant.img || giftModalState.product.img );
      addItems();
    }

    $( `.wine-modal__centerCenter__close` ).click();
    $( `.wine-header__cart [cart-count]` ).click();
  } catch ( err ) {
    console.log( `ERROR addGiftVariantToCart`, err.message );
  }
}

